import {useCallback, useRef, useState} from 'react';
import {Button} from '../../atoms/Button';
import {InputText} from '../../atoms/InputText';
import {Typography} from '../../atoms/Typography';
import {coin} from '../../sass/base/_exports.sass';
import {ArrowIcon} from '../../svg/ArrowIcon';

const defaultSubscribeMessage = 'Join our email list for party tips, updates, and offers.';
const THREE_SECONDS_IN_MS = 3000;

export const NewsletterSignup = (props) => {
  const {subscribeMessage = defaultSubscribeMessage} = props;
  const [inputValue, setInputValue] = useState('');
  const [messageText, setMessageText] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);
  const [cityFieldAccessed, setCityFieldAccessed] = useState(false);
  const timeOnMountInMs = useRef(Date.now());

  const handleAjaxResponse = useCallback((message, success = true) => {
    const feedbackBlock = document.getElementById('newsletter-feedback');
    setMessageText(message);
    setIsSuccess(success);
    evite.removeClass(feedbackBlock, 'hidden');
  }, []);

  const subscribe = useCallback(
    (e) => {
      if (Date.now() - timeOnMountInMs.current < THREE_SECONDS_IN_MS || cityFieldAccessed) {
        return;
      }

      e.preventDefault();

      const data = {
        email_addr: inputValue,
        marketing_source: 'site_footer',
      };

      $.ajax({
        url: '/ajax/subscribe/',
        dataType: 'json',
        type: 'POST',
        timeout: 10000,
        data,
        success(response) {
          handleAjaxResponse(response.message);
        },
        error(xhr) {
          handleAjaxResponse(xhr.responseJSON.message, false);
        },
      });
    },
    [cityFieldAccessed, inputValue, handleAjaxResponse]
  );

  const handleInputChange = (e) => {
    const feedbackBlock = document.getElementById('newsletter-feedback');
    setMessageText('');
    setInputValue(e.target.value);
    evite.addClass(feedbackBlock, 'hidden');
  };

  return (
    <form className="evite-form" onSubmit={subscribe}>
      <ul id="newsletter-signup" className="newsletter-signup" role="presentation">
        <li className="header3 footer__subscribe" id="subscribe_message">
          <Typography as="h3" variant="header6">
            {subscribeMessage}
          </Typography>
        </li>
        {/* Do not delete this input field - Explanation is in this Jira Ticket - EVT-34113 */}
        <li className="city-field">
          <input
            type="text"
            name="City"
            data-qa-id="footer_city"
            autoComplete="off"
            tabIndex="-1"
            onChange={() => setCityFieldAccessed(true)}
          />
        </li>
        <li>
          <InputText
            type="text"
            data-qa-id="footer_email"
            value={inputValue}
            success={isSuccess ? messageText : null}
            error={!isSuccess ? messageText : null}
            onChange={handleInputChange}
            placeholder="Enter your email address"
            endAdornment={
              <Button
                variant="transparent"
                onClick={subscribe}
                data-qa-id="footer_submit"
                ariaLabel="submit email address"
              >
                <ArrowIcon ratio={0.5} color={coin} />
              </Button>
            }
          />
        </li>
      </ul>
    </form>
  );
};
